module.exports = __webpack_public_path__ + "static/img/color.62085475.jpg";